angular.module('lsnBase.deprecated.models')
  .factory('BonusMalusContinuationModel', ['LsnBonusMalusContinuationModelV1',
    function(LsnBonusMalusContinuationModelV1) {
      return LsnBonusMalusContinuationModelV1;
    }
  ]);